import PropTypes from 'prop-types';

import Title from './Title';
import Description from './Description';
import Svg404 from 'assets/svg/404.svg';

export default function _404({ title, description }) {
  return (
    <>
      <img src={Svg404} style={{ height: '40%' }} />
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
    </>
  );
}

_404.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};
